module.exports = __webpack_public_path__ + "static/img/cont60 (5).a2aa102.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont60 (5).jpg
// module id = lYTI
// module chunks = 0